import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminDashboardLayer from "./AdminDashboardLayer";

const AdminDashboard = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Admin Dashboard" />

        {/* AdminDashboardLayer */}
        <AdminDashboardLayer />
        
      </MasterLayout>
    </>
  );
};

export default AdminDashboard;
